import { makeStyles } from "@material-ui/core";

export const useErrorBoxStyles = makeStyles((theme) => ({
  error: {
    "font-size": "16px",
    "& .MuiAlertTitle-root": {
      "font-size": "18px",
    },
  },

  errorWrapper: {
    width: "100%",
    display: "flex",
    "justify-content": "center",
    "align-items": "center",
  },

  fullHeight: {
    height: "100%",
  },
}));
